import { render, staticRenderFns } from "./OwnerInfoCard.vue?vue&type=template&id=70284ca5&scoped=true&"
import script from "./OwnerInfoCard.vue?vue&type=script&lang=js&"
export * from "./OwnerInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./OwnerInfoCard.vue?vue&type=style&index=0&id=70284ca5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70284ca5",
  null
  
)

export default component.exports